export class FetchUser {
  static readonly type = '[User] Fetch User';
  constructor(
    public userId: string,
    public cached = true,
  ) {}
}

export class FetchUsersByIds {
  static readonly type = '[User] Fetch Users By Ids';
  constructor(public ids: string[]) {}
}

export class FetchCurrentUserProfile {
  static readonly type = '[User] Fetch Current User';
  constructor(public cached = true) {}
}

export class ResetUserPassword {
  static readonly type = '[User] reset User password';
  constructor(public userId: string) {}
}

export class TransitoryFetchMyOrgUsers {
  static readonly type = '[User] Fetch My Org Users';
}

export class FetchCurrentUserGroups {
  static readonly type = '[User] Fetch Current User Groups';
  constructor(public cached = true) {}
}

export class ActivateUser {
  static readonly type = '[User] Activate User';
  constructor(public userId: string) {}
}

export class DeactivateUser {
  static readonly type = '[User] Deactivate User';
  constructor(public userId: string) {}
}
